import React from "react";
import { CheckCircle2, Eye, Bell } from "lucide-react";
import { NIGHT, NIGHT_2, BORDER_ON_DARK, MINT, CONTAINER } from "../tokens";

interface Item {
  icon: React.ComponentType<{ size?: number; color?: string }>;
  title: string;
  body: string;
}

export default function TrustSection() {
  const items: Item[] = [
    { icon: CheckCircle2, title: "Nothing pays without your approval", body: "Hours fill in automatically, but the pay run waits for your review. If someone misses a clock out, you fix it before pay runs." },
    { icon: Eye, title: "Everyone sees only what they should", body: "Each person sees their own pay and schedule. You see everyone. Clear roles, no oversharing." },
    { icon: Bell, title: "Reminders keep hours honest", body: "If a phone leaves the work location while still clocked in, Novala sends a reminder to clock out, so hours do not run long by accident." },
  ];
  return (
    <section style={{ background: NIGHT, color: "#FFFFFF", padding: "100px 0" }}>
      <div style={CONTAINER}>
        <div style={{ textAlign: "center", maxWidth: 740, margin: "0 auto 50px" }}>
          <span style={{ display: "inline-block", fontSize: 12, fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase", color: MINT, marginBottom: 12 }}>Trust, built in</span>
          <h2 style={{ fontSize: "clamp(32px, 4vw, 42px)", fontWeight: 800, color: "#FFFFFF", letterSpacing: "-0.02em", lineHeight: 1.1, margin: "0 0 18px" }}>
            Automatic, but never out of your hands
          </h2>
          <p style={{ fontSize: 16, color: "rgba(240, 250, 248, 0.75)", lineHeight: 1.6, margin: 0 }}>
            Hours fill in on their own, and you stay fully in control of what gets paid.
          </p>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 18 }}>
          {items.map((it, i) => {
            const Icon = it.icon;
            return (
              <div key={i} style={{ background: NIGHT_2, border: "0.5px solid " + BORDER_ON_DARK, borderRadius: 14, padding: 28 }}>
                <div style={{ width: 44, height: 44, borderRadius: 11, background: "rgba(47, 227, 190, 0.10)", display: "grid", placeItems: "center", marginBottom: 18 }}>
                  <Icon size={22} color={MINT} />
                </div>
                <div style={{ fontSize: 17, fontWeight: 700, color: "#FFFFFF", letterSpacing: "-0.01em", marginBottom: 10 }}>{it.title}</div>
                <p style={{ fontSize: 14, color: "rgba(240, 250, 248, 0.72)", lineHeight: 1.6, margin: 0 }}>{it.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}